var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserMonitoring(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9.75003V11.25H0V9.75003C0 9.75003 0 6.75003 5.25 6.75003C10.5 6.75003 10.5 9.75003 10.5 9.75003ZM7.875 2.62503C7.875 2.10585 7.72105 1.59834 7.43261 1.16666C7.14417 0.734977 6.7342 0.398524 6.25454 0.199844C5.77489 0.00116392 5.24709 -0.0508198 4.73789 0.0504664C4.22869 0.151753 3.76096 0.40176 3.39384 0.768873C3.02673 1.13599 2.77672 1.60372 2.67544 2.11292C2.57415 2.62212 2.62614 3.14992 2.82482 3.62957C3.0235 4.10923 3.35995 4.5192 3.79163 4.80764C4.22331 5.09607 4.73082 5.25003 5.25 5.25003C5.94619 5.25003 6.61387 4.97347 7.10615 4.48118C7.59844 3.9889 7.875 3.32122 7.875 2.62503ZM10.455 6.75003C10.9161 7.10684 11.2933 7.56035 11.5603 8.07866C11.8272 8.59696 11.9773 9.16747 12 9.75003V11.25H15V9.75003C15 9.75003 15 7.02753 10.455 6.75003ZM9.75 2.75974e-05C9.23383 -0.00237326 8.72909 0.151926 8.3025 0.442528C8.75808 1.07908 9.00304 1.84224 9.00304 2.62503C9.00304 3.40781 8.75808 4.17098 8.3025 4.80753C8.72909 5.09813 9.23383 5.25243 9.75 5.25003C10.4462 5.25003 11.1139 4.97347 11.6062 4.48118C12.0984 3.9889 12.375 3.32122 12.375 2.62503C12.375 1.92883 12.0984 1.26116 11.6062 0.768873C11.1139 0.27659 10.4462 2.75974e-05 9.75 2.75974e-05Z",
    fill: "url(#paint0_linear_9201_8776)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9201_8776",
    x1: 0,
    y1: 5.62501,
    x2: 15,
    y2: 5.62501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52FAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#197AD0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMonitoring);
export default __webpack_public_path__ + "static/media/user-monitoring.6faf981680f3b21855661fed61d3daac.svg";
export { ForwardRef as ReactComponent };